import styled from "@emotion/styled";
import { MOBILE_QUERY_MAX_WIDTH_M } from "constants/vp-sizes";
export const StyledGetStartedContactSalesComboButton = styled.div`
  display: flex;
  align-items: center;
  column-gap: 24px;
  flex-wrap: wrap;
  justify-content:  ${({ buttonsAlign })=>buttonsAlign || "center"};

  &.swap-buttons-order {
    flex-direction: row-reverse;
  }

  .contact-sales-button-wrapper {
    height: 50px;
    display: flex;
    align-items: center;

    .button-component {
      padding-left: 37px;
      padding-right: 37px;
    }
  }

  .additional-button-text {
    width: 100%;
    text-align: center;
    font-size: 0.875rem;
  }

  @media (max-width: ${MOBILE_QUERY_MAX_WIDTH_M}) {
    flex-direction: column;
    align-items: center;
    gap: 16px;

    &.swap-buttons-order {
      flex-direction: column;
    }
  }
`;
